(function () {
  var EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var POSTED_KEY = 'newsletter-footer-posted';

  // El mensaje de exito ya no se pinta desde JS: lo renderiza el servidor en
  // sections/newsleter.liquid dentro de {% if form.posted_successfully? %},
  // cuando Shopify devuelve al visitante con ?customer_posted=true.

  // El envio es nativo porque el CAPTCHA de la tienda solo protege ese camino
  // (por AJAX, /contact responde 400 "Missing CAPTCHA token" y no se guarda
  // nadie). Eso obliga a recargar, y el navegador arranca arriba del todo: el
  // visitante veia el header y no se enteraba de que se habia suscrito, con el
  // mensaje de exito a varias pantallas de scroll. Lo llevamos de vuelta al
  // formulario.
  function volverAlFormulario() {
    if (location.search.indexOf('customer_posted=true') === -1) return;

    // Si el alta salio del modal, se encarga el modal: se reabre en exito. Se
    // usan marcas distintas justamente para no pisarse.
    var vinoDeAca = false;
    try {
      vinoDeAca = sessionStorage.getItem(POSTED_KEY) === '1';
      sessionStorage.removeItem(POSTED_KEY);
    } catch (err) {}
    if (!vinoDeAca) return;

    var destino = document.querySelector('.newsletter-form__success') ||
                  document.querySelector('.newsletter-section') ||
                  document.querySelector('.newsletter-form');
    if (!destino) return;

    // 'instant' a proposito: con smooth el navegador pelea con su propia
    // restauracion de scroll y el salto se ve peor que no hacer nada.
    try { destino.scrollIntoView({ block: 'center', behavior: 'instant' }); }
    catch (err) { destino.scrollIntoView(); }

    // Que un lector de pantalla tambien se entere, no solo quien ve.
    var aviso = destino.querySelector('[role="status"]') || destino;
    if (aviso && aviso.focus) {
      aviso.setAttribute('tabindex', '-1');
      try { aviso.focus({ preventScroll: true }); } catch (err) { aviso.focus(); }
    }
  }

  function bindForm(form) {
    if (form.dataset.nlBound === '1') return;
    form.dataset.nlBound = '1';

    if (form.action) {
      try { form.action = form.action.split('#')[0]; } catch (err) {}
    }

    var input = form.querySelector('.newsletter-form__input');
    var button = form.querySelector('.newsletter-form__button');

    function showInlineError(msg) {
      var live = form.querySelector('.newsletter-form__live');
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      var p = document.createElement('p');
      p.className = 'newsletter-form__message newsletter-form__message--error newsletter-form__message--client';
      p.setAttribute('role', 'alert');
      p.textContent = msg;
      (live || form).appendChild(p);
    }

    function clearInlineError() {
      var existing = form.querySelector('.newsletter-form__message--client');
      if (existing) existing.remove();
      if (input) input.setAttribute('aria-invalid', 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    // OJO: este handler NO debe frenar el envio cuando el mail es valido.
    //
    // La tienda tiene la proteccion anti-spam de Shopify activada, y el CAPTCHA
    // se engancha al evento submit NATIVO del form generado por {% form %}.
    // Mandar el mail por fetch() lo saltea: /contact responde 400 con
    // {"errors":"Missing CAPTCHA token"} y el suscriptor no se guarda. Peor: el
    // .then() de fetch corre igual en un 400 (solo rechaza ante fallo de red),
    // asi que renderSuccess() mostraba "¡Gracias por suscribirte!" a todo el
    // mundo mientras no se guardaba nadie. Medido contra produccion el
    // 2026-08-05 con los campos exactos de este form.
    //
    // El stopImmediatePropagation() de antes ademas mataba al listener del
    // propio CAPTCHA de Shopify, con lo cual no habia arreglo posible por AJAX.
    //
    // Ahora solo validamos: si el mail sirve, dejamos pasar el submit nativo.
    // Shopify agrega el token, guarda, y vuelve con ?customer_posted=true; el
    // exito lo pinta sections/newsleter.liquid con form.posted_successfully?.
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('input[name="contact[website]"]');
      if (hp && hp.value) {
        e.preventDefault();
        return;
      }

      var value = input ? input.value.trim() : '';
      if (!EMAIL_RX.test(value)) {
        e.preventDefault();
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
        showInlineError('Ingresá un email válido.');
        return;
      }

      clearInlineError();

      // Marca de que el alta salio de ESTE formulario y no del modal: los dos
      // vuelven con ?customer_posted=true y hay que distinguirlos para saber
      // adonde llevar al visitante al recargar.
      try { sessionStorage.setItem(POSTED_KEY, '1'); } catch (err) {}

      // Deshabilitar en el proximo tick: si lo hacemos dentro del propio evento,
      // algunos navegadores descartan el boton como submitter del envio.
      if (button) {
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.textContent = 'Enviando...';
        window.setTimeout(function () { button.disabled = true; }, 0);
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.newsletter-form').forEach(bindForm);
  }

  init();
  volverAlFormulario();

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section) return;
    section.querySelectorAll('.newsletter-form').forEach(function (f) {
      f.dataset.nlBound = '';
    });
    init(section);
  });
})();
